import React from 'react';
import styles from './TableProfile.module.scss';
import { ProfileImage } from 'new/elements/ProfileImage';
import Typography from '@mui/material/Typography';

interface TableProfileProps {
  image?: string;
  name?: string;
}

export function TableProfile(props: TableProfileProps) {
  return (
    <div className={styles.profile}>
      <ProfileImage size="small" fullName={props.name} source={props.image} />
      <Typography variant="caption">{props.name}</Typography>
    </div>
  );
}
